import React, { useContext } from 'react'
import UserContext from '../../../UserContext'
import { TagSelector } from '../../Common/TagSelector'
import { ServicesFilter, ServiceRequestFilterGroup } from '../types'
import { SaveEvent, TabChangeEvent } from '../../Common/AnalyticsEvents'
import { ServiceRequestContext } from '../ServiceRequestContext'
import { SERVICE_REQUEST_TABS } from '../constants'

type FilterTagsProps = {
    tags: string[]
    activeFilterTag: string
    setActiveFilterTag: (tag: string) => void
    filters: ServicesFilter
    onFilter: (filters: ServicesFilter) => void
    onTagSelected?: () => void
    suppressActiveTag?: boolean
}

const FilterTags: React.FC<FilterTagsProps> = ({ onFilter, filters, tags, activeFilterTag, setActiveFilterTag, onTagSelected, suppressActiveTag }) => {
    const userContext = useContext(UserContext)
    const { loading, resetExpiredUnassignedCriteria } = useContext(ServiceRequestContext)

    const tabToFilterGroup: Partial<Record<string, ServiceRequestFilterGroup>> = {
        [SERVICE_REQUEST_TABS.OPEN_POSTINGS]: 'Open',
        [SERVICE_REQUEST_TABS.MY_OPEN]: 'Open',
        [SERVICE_REQUEST_TABS.MY_RESPONSES]: 'Responses',
        [SERVICE_REQUEST_TABS.AWARDED]: 'Awarded',
        [SERVICE_REQUEST_TABS.MY_AWARDED]: 'Awarded',
        [SERVICE_REQUEST_TABS.ALL]: 'All'
    }

    const nextStatus = filters.status && filters.status !== 'Draft'
        ? filters.status
        : filters.lastNonDraftStatus || 'Active'

    const doFilters = (filterName: string) => {
        onTagSelected?.()
        SaveEvent(TabChangeEvent(userContext, 'Service Request', filterName, activeFilterTag))
        setActiveFilterTag(filterName)

        if (filterName === SERVICE_REQUEST_TABS.EXPIRED_UNASSIGNED) {
            resetExpiredUnassignedCriteria()
            return
        }

        onFilter({
            ...filters,
            rowIndex: 0,
            lastNonDraftStatus: nextStatus,
            status: nextStatus,
            filterGroup: tabToFilterGroup[filterName] || filters.filterGroup
        })
    }

    return <TagSelector tags={tags} activeTag={activeFilterTag} setActiveTag={doFilters} disabled={loading} suppressActiveTag={suppressActiveTag} />
}

export default FilterTags
